import React, { useState } from "react";
import {
  Container,
  TextField,
  Typography,
  Button,
  Paper,
  Box,
  CircularProgress,
} from "@mui/material";
import { investorApi } from "../../../api/api";
import { useSelector } from "react-redux";
import SecondaryButton from "../../common/SecondaryButton";
import GradientButton from "../../common/GradiantButton";

const SendMessage = () => {
  const userId = useSelector((state) => state.user.userId);
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const theme = useSelector((data) => data.themeValue.colors)
  const handleSendMessage = async () => {
    if (!message.trim()) {
      alert("❗ Please enter a message before submitting.");
      return;
    }

    setSubmitting(true);
    try {
      const requestData = {
        UserId: userId,
        question: message,
      };
      const response = await investorApi.addMessage(requestData);
      if (response.status === 201) {
        alert(" Your question has been submitted successfully!");
        setMessage(""); // Clear input field
      } else {
        alert(" Something went wrong. Please try again.");
      }
    } catch (err) {
      alert(" Failed to send message. Check your network.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Paper
        elevation={4}
        sx={{
          p: 4,
          borderRadius: 3,
          boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
          backgroundColor: theme.background
        }}
      >
        <Typography variant="h5" fontWeight="bold" mb={3} sx={{ color: theme.text }}>
          Need Support? Ask Your Question
        </Typography>

        <TextField
          label="Type your message"
          multiline
          rows={5}
          fullWidth
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message here..."
          sx={{
            mb: 3,
            // Change label color
            '& label': {
              color: theme.text,
            },
            '& label.Mui-focused': {
              color: theme.primary_color,
            },
            // Style the outlined input
            '& .MuiOutlinedInput-root': {
              '& textarea': {
                color: theme.text,
              },
              '& fieldset': {
                borderColor: theme.text,
              },
              '&:hover fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-focused fieldset': {
                borderColor: theme.primary_color,
              },
            },
          }}
        />
         
         <GradientButton
         onClick={handleSendMessage}
          disabled={submitting}
          text={submitting ? "Submitting..." : "Submit"}
          width="100%"/>
        {submitting && (
          <Box sx={{ textAlign: "center", mt: 2 }}>
            <CircularProgress size={28} />
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default SendMessage;
